module.exports = __webpack_public_path__ + "static/media/meds.430174c7.png";